module.exports = "<div class=\"nn-base-notify nn-base-notify--{{ status }}\"><p ng-repeat=\"notify in notifications track by $index\">{{ get(notify, path, notify) | translate }}</p></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-notify/nn-base-notify.directive.html
// module id = 958
// module chunks = 0